"use strict";
exports.__esModule = true;
exports.toResult = exports.wrapWithResult = void 0;
exports.wrapWithResult = function (expectedType, validator) { return function (value) { return exports.toResult(validator(value), expectedType); }; };
exports.toResult = function (valid, expectedType, nestedProperty, nestedValue) { return ({
    valid: valid,
    expectedType: expectedType,
    nestedProperty: nestedProperty,
    nestedValue: nestedValue
}); };
//# sourceMappingURL=result.js.map